// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.promo-codes-page .section-item-title, .promo-codes-page .section-subtitle {
  overflow-wrap: anywhere;
}
.promo-codes-page .section-item-head > div {
  min-width: 0;
}
.promo-codes-page .promo-row-usage {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 14px;
  margin-top: 10px;
  font-size: 12px;
  color: #75829a;
}
.promo-codes-page .promo-row-usage strong {
  color: #262439;
  font-size: 14px;
  font-variant-numeric: tabular-nums;
}
.promo-codes-page .promo-stats .section-grid {
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 6px;
}
.promo-codes-page .promo-stats .section-stat {
  padding: 9px;
  border-radius: 10px;
}
.promo-codes-page .promo-stats .section-stat-label {
  font-size: 11px;
}
.promo-codes-page .promo-stats .section-stat-value {
  font-size: 16px;
}
.promo-codes-page .promo-analytics .section-item-head {
  align-items: center;
  gap: 8px;
}
.promo-codes-page .promo-analytics .section-subtitle {
  margin: 0;
  font-size: 16px;
  flex: 1 1;
}
.promo-codes-page .promo-analytics .section-helper {
  margin: 6px 0;
  font-size: 12px;
}
.promo-codes-page .promo-analytics-refresh {
  flex: 0 0 44px;
  padding: 0;
  width: 44px;
  height: 44px;
}
.promo-codes-page .promo-analytics-refresh svg {
  width: 18px;
  height: 18px;
}
.promo-codes-page .promo-usage-metrics {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 6px;
  margin: 10px 0;
}
.promo-codes-page .promo-usage-metrics > div {
  min-width: 0;
  background: #f6f7fa;
  border-radius: 10px;
  padding: 10px 8px;
}
.promo-codes-page .promo-usage-metrics span {
  display: block;
  color: #75829a;
  font-size: 11px;
}
.promo-codes-page .promo-usage-metrics strong {
  display: block;
  margin-top: 4px;
  font-size: 23px;
  line-height: 1.15;
  overflow-wrap: anywhere;
  font-variant-numeric: tabular-nums;
}
.promo-codes-page .promo-usage-metrics > div:first-child {
  background: #fff1f3;
  color: #de243e;
}
.promo-codes-page .promo-chart-title {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  margin-top: 14px;
  font-size: 13px;
  font-weight: 600;
}
.promo-codes-page .promo-usage-chart {
  display: flex;
  height: 64px;
  gap: 3px;
  border-bottom: 1px solid #dde2eb;
  margin: 10px 0 6px;
}
.promo-codes-page .promo-usage-chart > div {
  flex: 1 1;
  min-width: 0;
  display: flex;
  align-items: flex-end;
}
.promo-codes-page .promo-usage-chart span {
  width: 100%;
  min-height: 0;
  border-radius: 3px 3px 0 0;
  background: #e72f44;
}
.promo-codes-page .promo-chart-axis {
  display: flex;
  justify-content: space-between;
  color: #75829a;
  font-size: 10px;
}
.promo-codes-page .promo-usage-days {
  margin-top: 8px;
}
.promo-codes-page .promo-usage-days summary {
  display: flex;
  align-items: center;
  min-height: 44px;
  font-size: 13px;
  color: #65728b;
  cursor: pointer;
}
.promo-codes-page .promo-usage-days summary svg {
  margin-left: auto;
  width: 16px;
  height: 16px;
}
.promo-codes-page .promo-usage-days[open] summary svg {
  transform: rotate(180deg);
}
.promo-codes-page .promo-usage-days table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}
.promo-codes-page .promo-usage-days caption {
  text-align: left;
  color: #75829a;
  font-size: 11px;
  margin-bottom: 10px;
}
.promo-codes-page .promo-usage-days th, .promo-codes-page .promo-usage-days td {
  text-align: left;
  padding: 7px 0;
  border-bottom: 1px solid #eef0f5;
}
.promo-codes-page .promo-usage-days tbody th {
  font-weight: 400;
}
.promo-codes-page .promo-usage-days td, .promo-codes-page .promo-usage-days th:last-child {
  text-align: right;
}
.promo-codes-page .promo-analytics .promo-count-note {
  font-size: 11px;
  line-height: 1.45;
  margin-bottom: 0;
}
@media (max-width: 350px) {
  .promo-codes-page .promo-usage-metrics strong {
    font-size: 21px;
  }
  .promo-codes-page .section-inline {
    flex-direction: column;
  }
}

.lkfr-app .promo-codes-page .promo-analytics {
  padding: 14px;
}

.lkfr-app .promo-codes-page :is(.section-btn, .section-btn-secondary, .section-btn-danger) {
  min-height: 44px;
}`, "",{"version":3,"sources":["webpack://./src/pages/PromoCodesPage/promoUsage.scss"],"names":[],"mappings":"AACE;EAAyC,uBAAA;AAC3C;AAAE;EAA2B,YAAA;AAG7B;AAFE;EAAmB,aAAA;EAAe,eAAA;EAAiB,aAAA;EAAe,gBAAA;EAAkB,eAAA;EAAiB,cAAA;AAUvG;AATE;EAA0B,cAAA;EAAgB,eAAA;EAAiB,kCAAA;AAc7D;AAbE;EAA6B,gDAAA;EAAkD,QAAA;AAiBjF;AAhBE;EAA6B,YAAA;EAAc,mBAAA;AAoB7C;AAnBE;EAAmC,eAAA;AAsBrC;AArBE;EAAmC,eAAA;AAwBrC;AAvBE;EAAsC,mBAAA;EAAqB,QAAA;AA2B7D;AA1BE;EAAqC,SAAA;EAAW,eAAA;EAAiB,SAAA;AA+BnE;AA9BE;EAAmC,aAAA;EAAe,eAAA;AAkCpD;AAjCE;EAA2B,cAAA;EAAgB,UAAA;EAAY,WAAA;EAAa,YAAA;AAuCtE;AAtCE;EAA+B,WAAA;EAAa,YAAA;AA0C9C;AAzCE;EAAuB,aAAA;EAAe,gDAAA;EAAkD,QAAA;EAAU,cAAA;AA+CpG;AA9CE;EAA6B,YAAA;EAAc,mBAAA;EAAqB,mBAAA;EAAqB,iBAAA;AAoDvF;AAnDE;EAA4B,cAAA;EAAgB,cAAA;EAAgB,eAAA;AAwD9D;AAvDE;EAA8B,cAAA;EAAgB,eAAA;EAAiB,eAAA;EAAiB,iBAAA;EAAmB,uBAAA;EAAyB,kCAAA;AA+D9H;AA9DE;EAAyC,mBAAA;EAAqB,cAAA;AAkEhE;AAjEE;EAAqB,aAAA;EAAe,8BAAA;EAAgC,QAAA;EAAU,gBAAA;EAAkB,eAAA;EAAiB,gBAAA;AAyEnH;AAxEE;EAAqB,aAAA;EAAe,YAAA;EAAc,QAAA;EAAU,gCAAA;EAAkC,kBAAA;AA+EhG;AA9EE;EAA2B,SAAA;EAAS,YAAA;EAAc,aAAA;EAAe,qBAAA;AAoFnE;AAnFE;EAA0B,WAAA;EAAa,aAAA;EAAe,0BAAA;EAA4B,mBAAA;AAyFpF;AAxFE;EAAoB,aAAA;EAAe,8BAAA;EAAgC,cAAA;EAAgB,eAAA;AA8FrF;AA7FE;EAAoB,eAAA;AAgGtB;AA/FE;EAA4B,aAAA;EAAe,mBAAA;EAAqB,gBAAA;EAAkB,eAAA;EAAiB,cAAA;EAAgB,eAAA;AAuGrH;AAtGE;EAAgC,iBAAA;EAAmB,WAAA;EAAa,YAAA;AA2GlE;AA1GE;EAAsC,yBAAA;AA6GxC;AA5GE;EAA0B,WAAA;EAAa,yBAAA;EAA2B,eAAA;AAiHpE;AAhHE;EAA4B,gBAAA;EAAkB,cAAA;EAAgB,eAAA;EAAiB,mBAAA;AAsHjF;AArHE;EAA6C,gBAAA;EAAkB,cAAA;EAAgB,gCAAA;AA0HjF;AAzHE;EAA6B,gBAAA;AA4H/B;AA3HE;EAAwD,iBAAA;AA8H1D;AA7HE;EAAqC,eAAA;EAAiB,iBAAA;EAAmB,gBAAA;AAkI3E;AAjIE;EAA4B;IAA8B,eAAA;EAqI1D;EArI6E;IAAkB,sBAAA;EAwI/F;AACF;;AAvIA;EAA+C,aAAA;AA2I/C;;AA1IA;EAA6F,gBAAA;AA8I7F","sourcesContent":[".promo-codes-page {\n  .section-item-title, .section-subtitle { overflow-wrap: anywhere; }\n  .section-item-head > div { min-width: 0; }\n  .promo-row-usage { display: flex; flex-wrap: wrap; gap: 6px 14px; margin-top: 10px; font-size: 12px; color: #75829a; }\n  .promo-row-usage strong { color: #262439; font-size: 14px; font-variant-numeric: tabular-nums; }\n  .promo-stats .section-grid { grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 6px; }\n  .promo-stats .section-stat { padding: 9px; border-radius: 10px; }\n  .promo-stats .section-stat-label { font-size: 11px; }\n  .promo-stats .section-stat-value { font-size: 16px; }\n  .promo-analytics .section-item-head { align-items: center; gap: 8px; }\n  .promo-analytics .section-subtitle { margin: 0; font-size: 16px; flex: 1; }\n  .promo-analytics .section-helper { margin: 6px 0; font-size: 12px; }\n  .promo-analytics-refresh { flex: 0 0 44px; padding: 0; width: 44px; height: 44px; }\n  .promo-analytics-refresh svg { width: 18px; height: 18px; }\n  .promo-usage-metrics { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 6px; margin: 10px 0; }\n  .promo-usage-metrics > div { min-width: 0; background: #f6f7fa; border-radius: 10px; padding: 10px 8px; }\n  .promo-usage-metrics span { display: block; color: #75829a; font-size: 11px; }\n  .promo-usage-metrics strong { display: block; margin-top: 4px; font-size: 23px; line-height: 1.15; overflow-wrap: anywhere; font-variant-numeric: tabular-nums; }\n  .promo-usage-metrics > div:first-child { background: #fff1f3; color: #de243e; }\n  .promo-chart-title { display: flex; justify-content: space-between; gap: 8px; margin-top: 14px; font-size: 13px; font-weight: 600; }\n  .promo-usage-chart { display: flex; height: 64px; gap: 3px; border-bottom: 1px solid #dde2eb; margin: 10px 0 6px; }\n  .promo-usage-chart > div { flex: 1; min-width: 0; display: flex; align-items: flex-end; }\n  .promo-usage-chart span { width: 100%; min-height: 0; border-radius: 3px 3px 0 0; background: #e72f44; }\n  .promo-chart-axis { display: flex; justify-content: space-between; color: #75829a; font-size: 10px; }\n  .promo-usage-days { margin-top: 8px; }\n  .promo-usage-days summary { display: flex; align-items: center; min-height: 44px; font-size: 13px; color: #65728b; cursor: pointer; }\n  .promo-usage-days summary svg { margin-left: auto; width: 16px; height: 16px; }\n  .promo-usage-days[open] summary svg { transform: rotate(180deg); }\n  .promo-usage-days table { width: 100%; border-collapse: collapse; font-size: 12px; }\n  .promo-usage-days caption { text-align: left; color: #75829a; font-size: 11px; margin-bottom: 10px; }\n  .promo-usage-days th, .promo-usage-days td { text-align: left; padding: 7px 0; border-bottom: 1px solid #eef0f5; }\n  .promo-usage-days tbody th { font-weight: 400; }\n  .promo-usage-days td, .promo-usage-days th:last-child { text-align: right; }\n  .promo-analytics .promo-count-note { font-size: 11px; line-height: 1.45; margin-bottom: 0; }\n  @media (max-width: 350px) { .promo-usage-metrics strong { font-size: 21px; } .section-inline { flex-direction: column; } }\n}\n.lkfr-app .promo-codes-page .promo-analytics { padding: 14px; }\n.lkfr-app .promo-codes-page :is(.section-btn, .section-btn-secondary, .section-btn-danger) { min-height: 44px; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
